import styled from 'styled-components'

const StyledDishDetailsContainer = styled.div`
  padding: 24px;
`
export default StyledDishDetailsContainer
